export enum NiveauAlerteValeur {
  Faible = 0,
  Moyen = 1,
  Important = 2  
}